"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconLeafFilled = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  viewBox: "0 0 18 18",
  ...props,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "lfc",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m1440 0v1892h-1440v-1892h1440z"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "lfb",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m17 0v8.4869c0 2.3823-0.82202 4.3967-2.466 6.0433s-3.6553 2.4699-6.034 2.4699c-1.0144 0-1.972-0.16641-2.8727-0.49923-0.90072-0.33282-1.7184-0.80577-2.4529-1.4189l-1.5741 1.5502c-0.1749 0.17517-0.3804 0.26275-0.61651 0.26275-0.23611 0-0.44162-0.087584-0.61651-0.26275-0.1749-0.17517-0.26235-0.37661-0.26235-0.60433s0.087449-0.43792 0.26235-0.6306l1.5478-1.5765c-0.61214-0.7357-1.0844-1.5502-1.4167-2.4436s-0.49846-1.8568-0.49846-2.8903c0-2.3648 0.82202-4.3704 2.466-6.017 1.644-1.6466 3.6553-2.4699 6.034-2.4699h8.5z"
      })
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      clipPath: "url(#lfc)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            clipPath: "url(#lfb)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              points: "0 0 17 0 17 17 0 17"
            })
          })
        })
      })
    })
  })]
});
var _default = exports.default = (0, _withIcon.default)('IconLeafFilled')(IconLeafFilled);